import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'

import PolicyLinksManager from '@/components/designSystem/PolicyLinksManager/index.vue'
import type { AuthorizationResourcesAndSubjects } from '@/types/authorization'


export default /*#__PURE__*/_defineComponent({
  __name: 'RestrictionPolicyTab',
  props: {
    resourceType: {},
    resourceId: {},
    companyId: {}
  },
  emits: ["update:isSaving", "update:hasUnsavedChanges"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





const managerRef = ref<InstanceType<typeof PolicyLinksManager> | null>(null)

const handleSave = async () => {
  await managerRef.value?.handleSave()
}

__expose({ handleSave })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PolicyLinksManager, {
    ref_key: "managerRef",
    ref: managerRef,
    "resource-type": props.resourceType,
    "resource-id": props.resourceId,
    "company-id": props.companyId,
    "onUpdate:isSaving": _cache[0] || (_cache[0] = ($event: any) => (emit('update:isSaving', $event))),
    "onUpdate:hasUnsavedChanges": _cache[1] || (_cache[1] = ($event: any) => (emit('update:hasUnsavedChanges', $event)))
  }, null, 8, ["resource-type", "resource-id", "company-id"]))
}
}

})